import { login } from './login';
import { passwordRecovery } from './passwordRecovery';
import { signup } from './signup';
import { updatePassword } from './updatePassword';

const es = { ...login, ...passwordRecovery, ...signup, ...updatePassword };

export default es;
